import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/blog/[slug]/BlogPostClient.tsx");
